/* ==========================================================================
   THEME SWITCHER MODULE (ICON ONLY TOGGLE)
   ========================================================================== */

let currentTheme = localStorage.getItem('hba_theme') || 'light';

export function initThemeSwitcher() {
  const themeToggles = document.querySelectorAll('.theme-toggle');

  // Set initial theme state
  applyTheme(currentTheme);

  themeToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      currentTheme = currentTheme === 'light' ? 'dark' : 'light';
      localStorage.setItem('hba_theme', currentTheme);
      applyTheme(currentTheme);
    });
  });
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  
  const themeToggles = document.querySelectorAll('.theme-toggle');
  const headerLogo = document.querySelector('.site-header .logo-image');

  // Update button icon only (no text wording)
  themeToggles.forEach(toggle => {
    const iconEl = toggle.querySelector('.theme-icon') || toggle;
    if (theme === 'dark') {
      if (iconEl.querySelector('.theme-icon')) {
        iconEl.querySelector('.theme-icon').textContent = '☀️';
      } else {
        iconEl.textContent = '☀️';
      }
      toggle.setAttribute('title', 'Switch to Light Theme');
      toggle.setAttribute('aria-label', 'Switch to Light Theme');
    } else {
      if (iconEl.querySelector('.theme-icon')) {
        iconEl.querySelector('.theme-icon').textContent = '🌙';
      } else {
        iconEl.textContent = '🌙';
      }
      toggle.setAttribute('title', 'Switch to Dark Theme');
      toggle.setAttribute('aria-label', 'Switch to Dark Theme');
    }
  });

  // Swap header logo for contrast
  if (headerLogo) {
    if (theme === 'dark') {
      headerLogo.src = '/images/hopebase-logo-white.png';
    } else {
      headerLogo.src = '/images/hopebase-logo.png';
    }
  }
}
